export default __webpack_public_path__ + "static/media/his-on-hold-video.d2880466.mp4";